import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAreasDesarrolloService,
  getAreaDesarrolloByIdService,
  updateAreaDesarrolloService,
  toggleAreaDesarrolloActiveService,
  getAccionesDesarrolloService,
  getAccionDesarrolloByIdService,
  createAccionDesarrolloService,
  createMultiplesAccionesService,
  updateAccionDesarrolloService,
  toggleAccionDesarrolloActiveService,
} from "../../../services/fortalezas/fortalezas.service";

// ============================================================
// ÁREAS DE DESARROLLO
// ============================================================

export const getAreasDesarrolloThunk = createAsyncThunk(
  "fortalezas/getAreas",
  async ({ page = 1, search = "" } = {}, { rejectWithValue }) => {
    try {
      return await getAreasDesarrolloService(page, search);
    } catch (error) {
      if (error.response?.status === 404) return rejectWithValue("Página no válida");
      const message = error.response?.data?.detail || error.response?.data?.message || "Error al obtener áreas de desarrollo";
      return rejectWithValue(message);
    }
  }
);

export const getAreaDesarrolloByIdThunk = createAsyncThunk(
  "fortalezas/getAreaById",
  async (id, { rejectWithValue }) => {
    try {
      return await getAreaDesarrolloByIdService(id);
    } catch (error) {
      const message = error.response?.data?.detail || error.response?.data?.message || "Error al obtener el área de desarrollo";
      return rejectWithValue(message);
    }
  }
);

export const updateAreaDesarrolloThunk = createAsyncThunk(
  "fortalezas/updateArea",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updateAreaDesarrolloService(id, payload);
    } catch (error) {
      const message = error.response?.data?.detail || error.response?.data?.message || "Error al actualizar el área de desarrollo";
      return rejectWithValue(message);
    }
  }
);

export const toggleAreaDesarrolloActiveThunk = createAsyncThunk(
  "fortalezas/toggleAreaActive",
  async (id, { rejectWithValue }) => {
    try {
      return await toggleAreaDesarrolloActiveService(id);
    } catch (error) {
      const message = error.response?.data?.detail || error.response?.data?.message || "Error al cambiar estado del área";
      return rejectWithValue(message);
    }
  }
);

// ============================================================
// ACCIONES DE DESARROLLO
// ============================================================

export const getAccionesDesarrolloThunk = createAsyncThunk(
  "fortalezas/getAcciones",
  async ({ page = 1, search = "", area = "", talento = "" } = {}, { rejectWithValue }) => {
    try {
      return await getAccionesDesarrolloService({ page, search, area, talento });
    } catch (error) {
      if (error.response?.status === 404) return rejectWithValue("Página no válida");
      const message = error.response?.data?.detail || error.response?.data?.message || "Error al obtener acciones de desarrollo";
      return rejectWithValue(message);
    }
  }
);

export const getAccionDesarrolloByIdThunk = createAsyncThunk(
  "fortalezas/getAccionById",
  async (id, { rejectWithValue }) => {
    try {
      return await getAccionDesarrolloByIdService(id);
    } catch (error) {
      const message = error.response?.data?.detail || error.response?.data?.message || "Error al obtener la acción de desarrollo";
      return rejectWithValue(message);
    }
  }
);

export const createAccionDesarrolloThunk = createAsyncThunk(
  "fortalezas/createAccion",
  async (payload, { rejectWithValue }) => {
    try {
      return await createAccionDesarrolloService(payload);
    } catch (error) {
      const message = error.response?.data?.detail || error.response?.data?.message || "Error al crear la acción de desarrollo";
      return rejectWithValue(message);
    }
  }
);

export const updateAccionDesarrolloThunk = createAsyncThunk(
  "fortalezas/updateAccion",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updateAccionDesarrolloService(id, payload);
    } catch (error) {
      const message = error.response?.data?.detail || error.response?.data?.message || "Error al actualizar la acción de desarrollo";
      return rejectWithValue(message);
    }
  }
);

export const toggleAccionDesarrolloActiveThunk = createAsyncThunk(
  "fortalezas/toggleAccionActive",
  async (id, { rejectWithValue }) => {
    try {
      return await toggleAccionDesarrolloActiveService(id);
    } catch (error) {
      const message = error.response?.data?.detail || error.response?.data?.message || "Error al cambiar estado de la acción";
      return rejectWithValue(message);
    }
  }
);

export const createMultiplesAccionesThunk = createAsyncThunk(
  "fortalezas/createMultiplesAcciones",
  async (payload, { rejectWithValue }) => {
    try {
      return await createMultiplesAccionesService(payload);
    } catch (error) {
      const message = error.response?.data?.detail || error.response?.data?.message || "Error al crear las acciones de desarrollo";
      return rejectWithValue(message);
    }
  }
);
